{
  "internal_id": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true
    }
  },
  "producing_formation_uuid": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "isNotRenderable": true
    }
  },
  "common_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation",
      "width": 160,
      "isShownByDefault": true
    }
  },
  "date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Month",
      "width": 100,
      "isShownByDefault": true
    }
  },
  "oil_equivalent_boe_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Production",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "oil_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Oil",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "natural_gas_mmcf_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mmcf/d"
    },
    "ui": {
      "label": "Natural Gas",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "condensate_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Condensate",
      "width": 120
    }
  },
  "ngl_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "C2+C3+C4",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "c5_cond_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "C5+Condensate",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "ngl_and_condensate_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "NGL & CND"
    }
  },
  "water_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Water",
      "width": 120
    }
  },
  "water_injection_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Water Injection",
      "width": 120
    }
  },
  "ethane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Ethane",
      "width": 120
    }
  },
  "propane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Propane",
      "width": 120
    }
  },
  "butane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Butane",
      "width": 120
    }
  },
  "pentane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Pentane",
      "width": 120
    }
  },
  "provinces_included": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true
    }
  },
  "license_count": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "# total"
    },
    "ui": {
      "label": "Producing Licence Count",
      "width": 120,
      "isShownByDefault": true
    }
  }
}

//"liquid_productions_bbl_d": {
//"source": "regulator",
//"domainType": "SIUnit",
//"domainTypeAttributes": {
//"symbol": "bbl/d"
//},
//"ui": {
//"label": "Liquid Production",
//"width": 120,
//"isShownByDefault": true
//}
//},

//"percent_of_production_as_liquids": {
//"source": "regulator",
//"domainType": "SIUnit",
//"domainTypeAttributes": {
//"symbol": "%"
//},
//"ui": {
//"label": "Percent of Production as Liquids"
//}
//}